import * as React from 'react';
import { Component } from "react"
import CopyrightIcon from '@mui/icons-material/Copyright';

class Constants extends Component {
    static CURRENCY_UNIT_LEFT = "￥"
    static CURRENCY_UNIT_LEFT_COIN = <CopyrightIcon />
    static CURRENCY_UNIT_RIGHT = "コイン"
}

export default Constants